import axios from 'axios';
import { saveAs } from 'file-saver';
import commonService from './common-service';
import { AS2_DOWNLOAD_URL } from '../constants/api';

const AS2_API_KEY = '4LCv4LCm4LGN4LCt4LC14LCCIOCwpOCwpuCxjeCwreCwteCwpOCwvw==';

class FLStockService {
  async addDrg(params) {
    try {
      let response = await commonService.postToServer('FLStocks/Drugs', params);
      if (response) {
        return { code: 200 };
      } else {
        throw new Error('Error');
      }
    } catch (e) {
      return e;
    }
  }

  async getFacByParent(parentId) {
    try {
      const response = await commonService.getFromServer('FLStocks/Facilities?parent=' + parentId, {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getDrugList(drgName) {
    try {
      const response = await commonService.getFromServer('FLStocks/Drugs?drug=' + drgName, {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getMasterDrugList(parentId, facId) {
    try {
      const response = await commonService.getFromServer('FLStocks?parent=' + parentId + '&fac_id=' + facId, {});
      if (response && typeof response === 'object' && !Array.isArray(response)) return response;
      return { drugs: [], doctors: [] };
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getParent() {
    try {
      const response = await commonService.getFromServer('FLStocks/Parents', {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async deleteDrg(drugId) {
    try {
      const response = await commonService.deleteToServer('FLStocks/Drugs/' + drugId, {});
      if (response) return response;
      throw new Error('Error while deleting drug. Please contact administrator.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async editDrg(params) {
    try {
      const response = await commonService.postToServer('FLStocks/Drugs', params);
      if (response) return response;
      throw new Error('Error while editing drug. Please contact administrator.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async saveQuantity(drugDetails) {
    try {
      const response = await commonService.postToServer('FLStocks', drugDetails);
      if (response) return response;
      throw new Error('Error in saving quantity. Please contact administrator.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async assignDr(params) {
    try {
      const response = await commonService.postToServer('FLStocks/Doctors', params);
      if (response) return response;
      throw new Error('Error in assigning doctor.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getDoctors() {
    try {
      const response = await commonService.getFromServer('FLStocks/Doctors', {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getSelectedDoc(fid) {
    try {
      const response = await commonService.getFromServer('FLStocks/Doctors/' + fid, {});
      if (response) return response;
      return {};
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getStockRep(params) {
    try {
      const response = await commonService.getFromServer('FLStocks/Report', params);
      if (response) return response;
      throw new Error('Error retrieving report.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async cpyParents(params) {
    try {
      const response = await commonService.postToServer(
        'FLStocks/CopyParent?source=' + params.source + '&target=' + params.target, {}
      );
      if (response) return response;
      throw new Error('Error in copying drugs.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async cpyfrmFacility(params) {
    try {
      const response = await commonService.postToServer(
        'FLStocks/CopyFacility?parent=' + params.parent + '&source=' + params.source + '&target=' + params.target, {}
      );
      if (response) return response;
      throw new Error('Error in copying drugs.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getApprovalRequests(facId) {
    try {
      const response = await commonService.getFromServer('FLStocks/Approval/' + facId, {});
      if (response) return response;
      throw new Error('Error retrieving approval requests.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async approve(model) {
    try {
      const response = await commonService.postToServer('FLStocks/Approve', model);
      if (response) return response;
      throw new Error('Error approving orders.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async deny(model) {
    try {
      const response = await commonService.postToServer('FLStocks/Deny', model);
      if (response) return response;
      throw new Error('Error denying orders.');
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async scanOrder(orderId) {
    try {
      const response = await commonService.postToServer(
        'Epcis/ScanOrder?orderId=' + encodeURIComponent(orderId),
        {}
      );

      if (response) return response;
      throw new Error('Error while scanning order.');
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getScanHistory() {
    try {
      const response = await commonService.getFromServer('Epcis/ScanHistory', {});
      return Array.isArray(response) ? response : [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadEpcisFile(fileName) {
    try {
      const response = await axios.get(AS2_DOWNLOAD_URL + fileName, {
        headers: { 'X-Api-Key': AS2_API_KEY },
        responseType: 'blob',
      });
      saveAs(new Blob([response.data]), fileName);
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
export default new FLStockService();
